/**
 * Attribution strings for map layers.
 *
 * Crediting GUGiK is not by itself enough: the PZGiK licence requires the
 * explicit sentence below wherever the material is presented. The layers used
 * to carry only the copyright line, so the map — the place the material is most
 * visible — was the one place the notice was missing.
 *
 * Keep in sync with the PHP counterpart, helpers/PzgikAttribution.php.
 */
export const PZGIK_NOTICE = 'Wykorzystano materiały państwowego zasobu geodezyjnego i kartograficznego';

const GUGIK_LINK = '&copy; <a href="https://www.geoportal.gov.pl/">Główny Urząd Geodezji i Kartografii</a>';
const KOWR_LINK = '<a href="https://www.gov.pl/web/kowr">Krajowy Ośrodek Wsparcia Rolnictwa</a>';
const PORT_POLSKA_LINK = '<a href="https://www.gov.pl/web/gugik/aktualizacja-uslugi-port-polska-w-serwisie-wwwgeoportalgovpl">Port Polska</a>';
const SIDUSIS_LINK = '<a href="https://internet.gov.pl/">internet.gov.pl</a>';

/**
 * Attribution for a layer sourced from PZGiK.
 *
 * @param {string} [datasetLabel] name of the dataset, appended after the credit
 * @returns {string} HTML for the map attribution control
 */
export function pzgikAttribution(datasetLabel) {
    const credit = datasetLabel ? `${GUGIK_LINK} — ${datasetLabel}` : GUGIK_LINK;
    return `${credit}. ${PZGIK_NOTICE}.`;
}

export function kowrAttribution() {
    return `Dane: ${KOWR_LINK}. Usługa WMS: ${GUGIK_LINK}.`;
}

export function portPolskaAttribution() {
    return `Dane: ${PORT_POLSKA_LINK} — plany rezerwacji terenu i zakazy inwestycyjne, pobrane z usługi ${GUGIK_LINK}.`;
}

export function sidusisAttribution() {
    return `Dane: ${SIDUSIS_LINK} — Ministerstwo Cyfryzacji.`;
}

export function ownershipAttribution() {
    return pzgikAttribution('Działki i grupy rejestrowe Ewidencji Gruntów i Budynków');
}

export function landUseAttribution() {
    return pzgikAttribution('Działki i użytki gruntowe Ewidencji Gruntów i Budynków');
}
